// Topnavhome.js
import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import {
    Navbar, Nav, Collapse, NavbarBrand, Row, Col,
    NavbarToggler, UncontrolledDropdown, DropdownItem, DropdownToggle, DropdownMenu,
    NavItem
} from 'reactstrap';
import { publicRoutes, dropdowns } from '../../data/publicRoutes.data';
import IntlMessages from '../../helpers/IntlMessages';
import Ricon from '../../public-routes/homepage/Icon';

const TopNav = (props) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [MaiMenuOpen, setMainMenuOpen] = useState(false);
    const [leftColumnVisible, setLeftColumnVisible] = useState(false);
    const [rightColumnVisible, setRightColumnVisible] = useState(false);
    const [showLeftMenuLinks, setShowLeftMenuLinks] = useState(false);
    const [showRightMenuLinks, setShowRightMenuLinks] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    // Left side links with "Main Sections" title
    const leftMenuLinks = [
        { id: 'contact-us', path: '/contact', label: 'Contact Us' },
        { id: 'about-us', path: '/about-us', label: 'About Us' },
        { id: 'services', path: '/services', label: 'Services' },
        { id: 'Industries we work with', path: '/sectors', label: 'Industries we work with' },
        { id: 'blog', path: '/blog', label: 'Blog' }
    ];

    // Right side links with "Our Services" title - using just URLs
    const rightMenuLinks = [
        { id: 'SEO', path: '/services/seo', label: 'SEO' },
        { id: 'Paid-media', path: '/services/paid-media', label: 'Paid Media' },
        { id: 'Branding', path: '/services/branding', label: 'Branding' },
        { id: 'Strategy & data', path: '/services/strategy', label: 'Strategy' },

    ];

    // Add scroll event listener
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleMenu = () => {
        if (!isMenuOpen) {
            // Opening menu
            setIsMenuOpen(true);
            setMainMenuOpen(true);
            setTimeout(() => setLeftColumnVisible(true), 100);
            setTimeout(() => setRightColumnVisible(true), 100);

            // Show left menu links with delay
            setTimeout(() => setShowLeftMenuLinks(true), 1000);
            // Show right menu links with slight delay for staggered effect
            setTimeout(() => setShowRightMenuLinks(true), 1000);
        } else {
            // Closing menu
            setRightColumnVisible(false);
            setShowLeftMenuLinks(false);
            setShowRightMenuLinks(false);
            setTimeout(() => setLeftColumnVisible(false), 100);
            setTimeout(() => setIsMenuOpen(false), 100);
            setTimeout(() => setMainMenuOpen(false), 1000);
        }
    };

    const handleLinkClick = () => {
        if (isMenuOpen) {
            setRightColumnVisible(false);
            setShowLeftMenuLinks(false);
            setShowRightMenuLinks(false);
            setTimeout(() => setLeftColumnVisible(false), 100);
            setTimeout(() => {
                setIsMenuOpen(false);
            }, 400);
        }
    };

    // Close menu on escape key
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && isMenuOpen) {
                toggleMenu();
            }
        };

        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
            document.addEventListener('keydown', handleEscape);
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isMenuOpen]);

    return (
        <>
            <Navbar
                fixed='top'
                className={`bg-dark navbar-island fixed-top d-flex ${isScrolled ? 'bg-dark navbar-scrolled' : ''}`}
                color="light"
                light
                expand="sm"
            >
                <NavbarBrand tag={Link} to="/" className="mr-3 navbar-brand-island">
                    <Ricon />
                </NavbarBrand>
                <Link
                    to='/'
                    className='logo-text'
                >
                    ReachTix
                </Link>

                <Link
                    to='/contact'
                    className='d-none d-md-block btn btn-primary btn-lg ml-auto'
                >
                    Get in touch
                </Link>

                <div
                    className={`hamburger  hamburger--spin ${isMenuOpen ? 'is-active' : ''}`}
                    type="button"
                    onClick={toggleMenu}
                    aria-label="Menu"
                    aria-controls="fullscreen-menu"
                    aria-expanded={isMenuOpen}
                >
                    <span className="hamburger-box">
                        <span className="hamburger-inner"></span>
                    </span>
                </div>

                <div className="d-none ml-auto header-icons align-middle">
                    {Object.keys(dropdowns).map((dropdownKey) => {
                        const dropdown = dropdowns[dropdownKey];
                        return (
                            <div key={dropdownKey} className="mx-3 position-relative d-none d-md-inline-block">
                                <NavLink className="px-3 btn btn-outline-primary ml-2" to="/register">
                                    <IntlMessages id="register" />
                                    <i className="fas fa-user-circle mx-2"></i>
                                </NavLink>
                            </div>
                        );
                    })}
                    <div className="mx-3 position-relative d-none d-md-inline-block">
                        <NavLink className="px-3 btn btn-outline-primary ml-2" to="/login">
                            <span className="button-text">
                                <IntlMessages id="login" />
                            </span>
                            <i className="fas fa-sign-in-alt mx-2"></i>
                        </NavLink>
                    </div>
                </div>
            </Navbar>

            {/* Full Screen Menu Overlay */}
            <div className={isMenuOpen ? " Menu opened fixed inset-0 size-full" : "d-flex Menu fixed inset-0 z-0 text-secondary theme-astronomy"}>
                <div className={`spinner-container ${isMenuOpen ? 'open' : 'close'}`}>
                    <div className="square-spinner">
                        <span>
                            <em></em>
                        </span>
                    </div>
                    <div className="reverse-spinner">
                        <span>
                            <em></em>
                        </span>
                    </div>
                </div>


                {isMenuOpen && (
                    <div className={`menu-content-wrapper ${showLeftMenuLinks ? 'visible' : ''}`}>
                        <Row className="menu-links-row g-0">
                            {/* Left Column - All Links Combined on Mobile */}
                            <Col md={6} className="left-column">
                                <div className="menu-section-left">
                                    {/* Main Sections Title - Always show */}
                                    <div className="menu-section-title" style={{
                                        opacity: showLeftMenuLinks ? 1 : 0,
                                        transform: showLeftMenuLinks ? 'translateY(0)' : 'translateY(30px)',
                                        transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
                                        transitionDelay: '0.1s'
                                    }}>
                                        <h1 className='text-white'>Main Sections</h1>
                                    </div>

                                    <div className="menu-links-container">
                                        {/* Left Menu Links */}
                                        {leftMenuLinks.map((link, index) => (
                                            <div
                                                key={link.id}
                                                className="menu-link-wrapper"
                                                style={{
                                                    opacity: showLeftMenuLinks ? 1 : 0,
                                                    transform: showLeftMenuLinks ? 'translateY(0)' : 'translateY(50px)',
                                                    transition: `all 0.7s cubic-bezier(0.16, 1, 0.3, 1)`,
                                                    transitionDelay: `${0.2 + (index * 0.08)}s`
                                                }}
                                            >
                                                <Link
                                                    to={link.path}
                                                    className="menu-link slide-up-link"
                                                    onClick={handleLinkClick}
                                                >
                                                    <span className="menu-link-text">{link.label}</span>
                                                </Link>
                                            </div>
                                        ))}

                                        {/* Services Separator for mobile - only show on small screens */}
                                        <div className="d-md-none services-separator" style={{
                                            opacity: showLeftMenuLinks ? 1 : 0,
                                            transform: showLeftMenuLinks ? 'translateY(0)' : 'translateY(30px)',
                                            transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
                                            transitionDelay: `${0.2 + (leftMenuLinks.length * 0.08)}s`
                                        }}>
                                            <h1 className='text-primary'>Our Services</h1>
                                        </div>

                                        {/* Right Menu Links - Only show on mobile in left column */}
                                        {rightMenuLinks.map((link, index) => (
                                            <div
                                                key={link.id}
                                                className="menu-link-wrapper d-md-none"
                                                style={{
                                                    opacity: showLeftMenuLinks ? 1 : 0,
                                                    transform: showLeftMenuLinks ? 'translateY(0)' : 'translateY(50px)',
                                                    transition: `all 0.7s cubic-bezier(0.16, 1, 0.3, 1)`,
                                                    transitionDelay: `${0.3 + (leftMenuLinks.length * 0.08) + (index * 0.08)}s`
                                                }}
                                            >
                                                <Link
                                                    to={link.path}
                                                    className="menu-link slide-up-link"
                                                    onClick={handleLinkClick}
                                                >
                                                    <span className="menu-link-text">{link.label}</span>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Col>

                            {/* Right Column - Only show on desktop */}
                            <Col md={6} className="right-column d-none d-md-flex">
                                <div className="menu-section-right">
                                    <div className="menu-section-title" style={{
                                        opacity: showRightMenuLinks ? 1 : 0,
                                        transform: showRightMenuLinks ? 'translateY(0)' : 'translateY(30px)',
                                        transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
                                        transitionDelay: '0.1s'
                                    }}>
                                        <h1 className='text-white'>Our Services </h1>
                                    </div>
                                    <div className="menu-links-container">
                                        {rightMenuLinks.map((link, index) => (
                                            <div
                                                key={link.id}
                                                className="menu-link-wrapper"
                                                style={{
                                                    opacity: showRightMenuLinks ? 1 : 0,
                                                    transform: showRightMenuLinks ? 'translateY(0)' : 'translateY(50px)',
                                                    transition: `all 0.7s cubic-bezier(0.16, 1, 0.3, 1)`,
                                                    transitionDelay: `${0.3 + (index * 0.08)}s`
                                                }}
                                            >
                                                <Link
                                                    to={link.path}
                                                    className="menu-link slide-up-link"
                                                    onClick={handleLinkClick}
                                                >
                                                    <span className="menu-link-text">{link.label}</span>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        </>
    );
};

export default TopNav;